// extracted by mini-css-extract-plugin
export default {"container":"Toggle_container__XaZSx","float_right":"Toggle_float_right__0spK0","center":"Toggle_center__exsqT","center_toggle":"Toggle_center_toggle__qHXyf"};